/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { UserCredentials } from "./UserCredentials";
import { ApiCredentials } from "./ApiCredentials";
export const Credentials = core.serialization
    .union("type", {
    userCredentials: UserCredentials,
    apiCredentials: ApiCredentials,
})
    .transform({
    transform: (value) => value,
    untransform: (value) => value,
});
